module.exports=function(){
    this.say=function(){
        console.log('liujin')
    }
    return this.say()
}
